import { LOCALIZATION_MAP } from '../../utils/constants'

const { CA, UK, AU } = LOCALIZATION_MAP
export const AMAZON_HOLIDAY_COPY = {
  [AU]: 'Need it ASAP? Order on Amazon',
  [CA]: 'Need it ASAP? Order on Amazon',
  [UK]: 'Need it ASAP? Order on Amazon',
}
